import { createStore } from 'vuex';
import loginModule from './loginModule';
import mdModal from '@/components/BaseUi/MessageModal/src';
import i18n from '@/i18n';
import { decryptAES } from '@/utils';

export default createStore({
  state: {
    isLogin: JSON.parse(sessionStorage.getItem('isLogin')) || false,
    userInfo:
      (sessionStorage.getItem('user') && JSON.parse(decryptAES(sessionStorage.getItem('user')))) ||
      null,
    retailAirportCode: JSON.parse(sessionStorage.getItem('retailAirportCode')) || null,
    retailCodes: JSON.parse(sessionStorage.getItem('retailCodes')) || null,
    isShowCookieBanner: JSON.parse(localStorage.getItem('isShowCookieBanner')) ?? true,
    globalLangList: [], // 语种列表
    globalLangData: {}, // 单个语种信息
    searchItem: JSON.parse(sessionStorage.getItem('searchItem')) || null,
    bankLogo: null,
    vcesStatus: sessionStorage.getItem('vcesStatus') || 0,
    loungeSearchCurrentTab: sessionStorage.getItem('loungeSearchCurrentTab') || 0,
    ingenicoFailRegister: sessionStorage.getItem('ingenicoFailRegister') || false,
    getcardData: JSON.parse(sessionStorage.getItem('getcardData')) || null,
    bandCardSuccessAfterIngenicoFail:
      sessionStorage.getItem('bandCardSuccessAfterIngenicoFail') || false,
    airportServiceCategoryIndex:
      JSON.parse(sessionStorage.getItem('airportServiceCategoryIndex')) || 0,
    test: '',
    visaCardType: sessionStorage.getItem('visaCardType') || null,
    // 是否来自于visa agent portal
    isFromPortal: false,
    mfaDetail: {
      callPrefix: '',
      phone: '',
      email: '',
    },
    // 是否有未读消息
    hasUnresdMsg: false,
    // 当前选择的dpcard
    currentDpCard: null,
    // 是否处于 ingenico update 流程中
    isIngenicoUpdatePending: false,
    // 是否因为 3ds 校验而触发刷新
    is3dsTriggeredReload: false,
  },

  mutations: {
    setState(state, payload) {
      state[payload.state] = payload.values;
    },

    // 展示信息弹窗
    showMessageModal(state, payload) {
      console.log('payload', payload);
      mdModal.show({
        image: false,
        desc: payload.i18nNeed ? i18n.global.t(payload.key) : payload.key,
        closeIcon: true,
        confirmBtn: 'ok',
        justHide: true,
      });
    },
    setHeaderBankLogo(state, payload) {
      state.bankLogo = payload;
    },
  },

  actions: {},

  modules: {
    loginModule,
  },
});
